import {
  WSCard,
  WSElement,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";

import { StepItem, Steps } from "../../../../shared/components/Steps";

type Props = {
  steps: StepItem[];
};

export const ApprovalWindowWidget: React.FC<Props> = ({ steps }) => (
  <WSElement>
    <WSSectionToolbar title="Approval window" />
    <WSCard mt="M">
      <Steps steps={steps} />
    </WSCard>
  </WSElement>
);
